import React from 'react';
import { observer, inject } from 'mobx-react';
import { Tabs } from '@/components/Common/Tabs';
import ProductList from './ProductList';

import SearchIcon from '@/assets/img/shape.svg';
import InputIcon from '@/assets/img/input-shape.svg';
import BackIcon from '@/assets/img/back.svg';
import ClearIcon from '@/assets/img/clear-icon.svg';
import ReturnIcon from '@/assets/img/return.svg';
import ImgNone from '@/assets/img/order_none@2x.png';
import { addObserver, removeObserver } from '@/utils/intersectionObserver';

import { getTrans, getChildInject } from '@/utils/instantLoaded/tools';
import {
  TO_PAY_TEXT,
  TO_SHIP_TEXT,
  TO_RECEIVE_TEXT,
  COMPLETED_TEXT,
  CANCELLED_TEXT,
  UNPAID_TEXT,
  SHIPPING_TEXT,
  BUYER_ORDER_LIST_TITLE_TEXT,
  SELLER_ORDER_LIST_TITLE_TEXT,
  SELECT_ORDER_CAN_NOT_FIND_TEXT,
  RETURN_REFUND_TEXT,
  ORDER_SHOW_TYPE,
  ALL_TEXT,
  SELECT_ORDER_TEXT,
  SELLER_RETURN_REFUND_TEXT,
  SELLER_CANCELLED_TEXT,
  SEARCH_ORDER_PLACEHOLDER,
  NO_ORDER_PLACEHOLDER_TEXT,
  NO_RESULT_FOUND_TEXT,
  SEARCH_ORDER_TEXT,
  SELLER_TEXT,
  TRACKING_SECTION,
  TRACKING_OPERATION,
  TRACKING_TARGET,
  TRACKING_TYPE,
  USER_TYPE_INDEX,
  LIVE_AGENT_USER_TYPE,
} from '@/utils/constants';


import { classnames } from '@/utils/tools';
import { trackingHandler } from '@/utils/btnClickHandler';
import { dispatchTrack, tracker } from '@/utils/tracking';
import './style.scss';

const prefixCls = 'product-list-tabs-container';

export const returnRefundType = -1;

const typeAll = 0;

const buyerQueryType = {
  toPay: 1,
  toShip: 2,
  toReceive: 3,
  completed: 4,
  cancelled: 5,
};

const sellerQueryType = {
  unPaid: 6,
  toShip: 7,
  shipped: 8,
  completed: 9,
  cancelled: 10,
};
@tracker
@inject(getChildInject('userStore', 'modalStore', 'agentStore', 'initStore'))
@observer
class ProductListTabs extends React.PureComponent {
  static defaultProps = {
    userStore: {},
    modalStore: {},
  };

  productListRef = React.createRef(null);
  buttonRef = React.createRef(null);
  inputRef = React.createRef(null);


  constructor(props) {
    super(props);
    const { agentStore, initStore, userStore, modalStore, userTypeLabel } = props;
    const { isForRR, show_type, dialogueId, dialogueType, is_seller, isSelectOrder } = modalStore.modalOrderList;

    const { inAgent, enquiryType, selectEnquiry } = agentStore;

    // 用户体验的优化 如果前面选了 seller 那么先进 seller 的 tab
    // LIVE_AGENT_USER_TYPE[2] 就是 seller 的 label
    const defaultSelectedUserTypeIndex = userTypeLabel === LIVE_AGENT_USER_TYPE[2] ? USER_TYPE_INDEX.Seller : USER_TYPE_INDEX.Buyer;
    this.state = {
      selectedUserTypeIndex: defaultSelectedUserTypeIndex,
      defaultSelected: 0, // 默认选中的tab为All
      isSearching: false,
      keyword: '',
      inputValue: '',
      isOnfocus: false,
      // titles: []
    };
    this.domRef = React.createRef();
    // this.listRef = React.createRef(null);

    this.buyerTitles = [
      { name: getTrans(ALL_TEXT), type: typeAll },
      { name: getTrans(TO_PAY_TEXT), type: buyerQueryType.toPay },
      { name: getTrans(TO_SHIP_TEXT), type: buyerQueryType.toShip },
      { name: getTrans(TO_RECEIVE_TEXT), type: buyerQueryType.toReceive },
      { name: getTrans(COMPLETED_TEXT), type: buyerQueryType.completed },
      { name: getTrans(CANCELLED_TEXT), type: buyerQueryType.cancelled },
    ];

    this.sellerTitles = [
      { name: getTrans(ALL_TEXT), type: typeAll },
      { name: getTrans(UNPAID_TEXT), type: sellerQueryType.unPaid },
      { name: getTrans(TO_SHIP_TEXT), type: sellerQueryType.toShip },
      { name: getTrans(SHIPPING_TEXT), type: sellerQueryType.shipped },
      { name: getTrans(COMPLETED_TEXT), type: sellerQueryType.completed },
      { name: getTrans(SELLER_CANCELLED_TEXT), type: sellerQueryType.cancelled },
    ];

    this.userTypes = [
      { name: getTrans(BUYER_ORDER_LIST_TITLE_TEXT), type: USER_TYPE_INDEX.Buyer },
      { name: getTrans(SELLER_ORDER_LIST_TITLE_TEXT), type: USER_TYPE_INDEX.Seller },
    ];

    // 埋点数据
    this.trackingData = {
      client_rank: userStore?.loyaltyTierCode?.toString() || '',
      current_chat_session_id: initStore?.sessionId,
      live_chat_session_id: agentStore?.connection?.sessionId,
      enquiry_type: agentStore?.enquiryType,
      account_type: userStore?.account_type,
    };

    this.iconTrackingData = {
      chat_session_id: initStore?.sessionId,
      chat_dialogue_id: dialogueId || '',
      origin: 'Search',
      button_name: 'search',
    };


    switch (show_type) {
      case ORDER_SHOW_TYPE.ORDER_BOT:
        this.state.defaultSelected = 0; // All
        if (!inAgent && !(isForRR || isSelectOrder)) {
          this.buyerTitles.push({ name: getTrans(RETURN_REFUND_TEXT), type: returnRefundType });
        }
        break;
      case ORDER_SHOW_TYPE.RR_BOT:
        this.state.defaultSelected = 2; // To receive
        break;
    }


    const NODE_MAP = {
      'CHECK': 'RR_Check',
      'RAISE': 'RR_Raise',
      'ORDER': 'Order',
    };


    // for RR 特殊配置
    if (isForRR || isSelectOrder) {
      this.buyerTitles.push({ name: getTrans(RETURN_REFUND_TEXT), type: returnRefundType });

      // 新节点下的checkrr 和 老节点的chekrr 的tab disabled
      if (isForRR || dialogueType === NODE_MAP.CHECK) {
        this.sellerTitles = this.sellerTitles.map((title) => ({
          disabled: true,
          ...title,
        }));
      }
      // 默认选中的tab为RR
      if (isForRR) {
        this.state.defaultSelected = this.buyerTitles.length - 1; // chek rr
      }

      this.sellerTitles.push({ name: getTrans(SELLER_RETURN_REFUND_TEXT), type: returnRefundType });
    }


    // 在agent中的配置
    if (inAgent) {
      this.buyerTitles.push({ name: getTrans(RETURN_REFUND_TEXT), type: returnRefundType });
      this.sellerTitles.push({ name: getTrans(SELLER_RETURN_REFUND_TEXT), type: returnRefundType });
      // 暂时只有sf进线判断卖家
      if (enquiryType.includes?.('Seller') || selectEnquiry.includes?.(getTrans(SELLER_TEXT))) {
        this.state.selectedUserTypeIndex = USER_TYPE_INDEX.Seller;
      }
    }


    // replytype31 的默认选中tab
    if (isSelectOrder) {
      switch (dialogueType) {
        case NODE_MAP.CHECK:
          this.state.defaultSelected = !is_seller ? this.buyerTitles.length - 1 : this.sellerTitles.length - 1; //  return refound
          break;
        case NODE_MAP.RAISE:
          if (!is_seller) {
            this.state.defaultSelected = 3; // To Ship
          }
          break;
        case NODE_MAP.ORDER:
          this.state.defaultSelected = 0; // All
          break;
      }
    }
  }

  componentDidMount() {
    addObserver(this.productListRef.current);
    addObserver(this.buttonRef.current);
  }

  // 只有在agent中才有MainTab可以切换
  handleMainTabClick(index, titles) {
    const trackingname = TRACKING_TYPE.MY_ORDER_LIST_MAIN_TAB;
    // 埋点数据增加Tab Name和SubTab Name
    const trackingdata = {
      tab_name: this.userTypes[index].name,
      subtab_name: titles[this.domRef.current.state.selected].name,
      ...this.trackingData,
    };
    trackingHandler({
      trackingname,
      trackingdata,
    });
    this.setState({
      selectedUserTypeIndex: index,
      subTabSelected: 0,
      // titles: index === USER_TYPE_INDEX.Buyer ? this.buyerTitles : this.sellerTitles
    });
  }

  trackingSubTabClickData() {
    const self = this;
    return (title) => {
      const { inAgent } = self.props.agentStore;
      if (inAgent) {
        const trackingname = TRACKING_TYPE.MY_ORDER_LIST_SUB_TAB;
        const trackingdata = {
          tab_name: self.userTypes[self.state.selectedUserTypeIndex].name,
          subtab_name: title.name,
          ...self.trackingData,
        };
        trackingHandler({
          trackingname,
          trackingdata,
        });
      }
    };
  }

  handleClickIcon() {

    const { dialogueId } = this.props.modalStore.modalOrderList;
    const trackingname = 'orderSelection';

    dispatchTrack({
      operation: TRACKING_OPERATION.ACTION_SEAECH,
      target: TRACKING_TARGET.button,
      section: TRACKING_SECTION[trackingname],
      data: {
        chat_session_id: this.props.initStore.sessionId || '0',
        chat_dialogue_id: dialogueId || '',
      },
    });

    this.setState({ isSearching: !this.state.isSearching });
  }

  handleSearchChange(e) {
    this.setState({ inputValue: e.target.value });
  }

  handleKeyDown(e) {
    const keyCode = e.keyCode;

    if (keyCode === 13) {
      this.setState({ keyword: e.target.value });
      e.preventDefault();
      this.listRef.loadMoreCb();
      this.inputRef.current.blur();
      this.setState({ isOnfocus: false });

      // fix键盘弹出页面整体会上移动
      setTimeout(() => {
        window.scrollTo(0, 0);
      });

    }
  }

  handleInputFocus() {
    this.setState({ isOnfocus: true });
  }

  handleInputBlur(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isOnfocus: false });
  }

  handleClear(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ inputValue: '' });
    this.inputRef.current.focus();
  }

  render() {
    const {
      modalStore,
      agentStore,
    } = this.props;
    const { is_seller, isSelectOrder } = modalStore.modalOrderList;

    const { inAgent } = agentStore;
    let titles = is_seller ? this.sellerTitles : this.buyerTitles;
    const title = is_seller ? getTrans(SELLER_ORDER_LIST_TITLE_TEXT) : getTrans(BUYER_ORDER_LIST_TITLE_TEXT);

    const $orderEmpty = <div className="order-empty">
      <img src={ImgNone} alt="empty" />
      {
        this.state.isSearching
          ? <p>{getTrans(NO_ORDER_PLACEHOLDER_TEXT)}</p>
          : <p>{getTrans(NO_RESULT_FOUND_TEXT)}</p>
      }

    </div>;

    if (inAgent) {
      titles = this.state.selectedUserTypeIndex === USER_TYPE_INDEX.Seller ? this.sellerTitles : this.buyerTitles;
    }

    return (<div className={prefixCls}>
      {/* 被选的enquiry type有isInboundOrder属性时（被绑定了要选order），展示buyer&seller tab*/}
      { (inAgent || this.props.isInboundOrder)
        ? <>
          <div className="agent-title">
            {this.props.isInboundOrder && <img className="back-icon" src={ReturnIcon} onClick={this.props.onReturn} />}
            {getTrans(SELECT_ORDER_TEXT)}
          </div>
          <div className="user-type-tabs">
            {this.userTypes.map((userType, index) => {
              return (<div key={index} className={classnames('user-type-item', { 'user-type-item-selected': index === this.state.selectedUserTypeIndex })} onClick={() => this.handleMainTabClick(index, titles)} >{userType.name}</div>);
            })}
          </div>
        </>
        : <>
          <div className="title">
            {(!is_seller && isSelectOrder && <img
              ref={this.productListRef}
              data-trackingname={TRACKING_SECTION.orderSelection}
              data-trackingdata={JSON.stringify({ ...this.iconTrackingData })}
              onClick={ this.handleClickIcon.bind(this)}
              className= { this.state.isSearching ? 'back-icon' : 'search-icon'}
              src={this.state.isSearching ? BackIcon : SearchIcon }/>
            )}
            <span>{this.state.isSearching ? getTrans(SEARCH_ORDER_TEXT) : title}</span>
          </div>
        </>

      }
      <div className={classnames('content-wrapper', { 'has-bottom': this.props.isInboundOrder }, 'chatbot_content_wrapper')}>
        {
          this.state.isSearching
            ? <div className="search-order-wrap">
              <div className="input-wrap">
                <form action="">
                  <input
                    type="search"
                    name="search"
                    id="search"
                    ref={this.inputRef}
                    value={this.state.inputValue}
                    onChange={this.handleSearchChange.bind(this)}
                    onKeyDown={this.handleKeyDown.bind(this)}
                    className="search-order-input"
                    style={{ paddingRight: this.inputValue ? '2.5rem' : 0 }}
                    onBlur={() => { this.handleInputBlur.bind(this); }}
                    onFocus={() => { this.handleInputFocus(); }}
                    placeholder={getTrans(SEARCH_ORDER_PLACEHOLDER)} />
                </form>

                <img
                  className="input-icon"
                  src={InputIcon}/>
                {
                  (this.state.isOnfocus && this.state.inputValue)
                && <img
                  onClick={this.handleClear.bind(this)}
                  className="clear-icon"
                  src={ClearIcon}/>
                }
              </div>
              {/* {$orderEmpty} */}
              <div className="search-list list-warpper">
                <ProductList
                // key={index}
                  buttonRef={this.buttonRef}
                  onRef={(ref) => { this.listRef = ref; }}
                  type={title.type}
                  name={title.name}
                  inputValue={this.state.inputValue}
                  keyword={this.state.keyword}
                  isOnfocus={this.state.isOnfocus}
                  isSearching={this.state.isSearching}
                  disabled={false}
                  isBuyer={this.state.selectedUserTypeIndex === USER_TYPE_INDEX.Buyer}
                  // TODO: isForRR 的情况下也会出现普通 order
                  isForRR={title.type === returnRefundType}
                />
              </div>

            </div>
            : <Tabs titles={this.state.isSearching ? [] : titles} ref={this.domRef}
              key={this.state.selectedUserTypeIndex}
              defaultSelected={this.state.defaultSelected}
              handleTrackingData={this.trackingSubTabClickData()}
              contentClass="list-warpper">
              {
                titles.map((title, index) => {
                  const trackingData = {
                    tab_name: this.userTypes[this.state.selectedUserTypeIndex].name,
                    subtab_name: title.name,
                    ...this.trackingData,
                  };
                  return (
                    <ProductList
                      key={index}
                      buttonRef={this.buttonRef}
                      onRef={(ref) => { this.listRef = ref; }}
                      type={title.type}
                      name={title.name}
                      subtabName={title.name}
                      disabled={title.disabled}
                      isBuyer={this.state.selectedUserTypeIndex === USER_TYPE_INDEX.Buyer}
                      trackingDataForAgent={trackingData}
                      // TODO: isForRR 的情况下也会出现普通 order
                      isForRR={title.type === returnRefundType}
                      isInboundOrder={this.props.isInboundOrder}
                      onClose={this.props.onClose}
                      onSubmit={this.props.onSubmit}
                    />
                  );
                })
              }
            </Tabs>
        }
      </div>
      {this.props.isInboundOrder && <div className="footer">
        <div className="button chatbot_footer_button"
          onClick={() => {
            this.props.onSubmit({ text: getTrans(SELECT_ORDER_CAN_NOT_FIND_TEXT) });
          }}>
          {getTrans(SELECT_ORDER_CAN_NOT_FIND_TEXT)}
        </div>
      </div>}
    </div>);
  }
}

export default ProductListTabs;
